export default {
	tokens: {
		columns: {
			created: "Erstellt",
			expires: "Läuft ab",
			lastUsed: "Zuletzt verwendet",
			revokedAt: "Widerrufen",
			permissions: "Berechtigungen",
		},
		never: "Nie",
		permissionCount: "{count} Berechtigung | {count} Berechtigungen",
		layerCount: "{count} Space | {count} Spaces",
		grantCount: "{count} | {count}",
		layerKind: { project: "Projekt", dataspace: "Dataspace" },
		state: {
			active: "Aktiv",
			suspended: "Ausgesetzt",
			expired: "Abgelaufen",
			revoked: "Widerrufen",
			deleted: "Gelöscht",
		},
		revokedBy: {
			admin: "von einem Admin",
			client: "beim Anbieter",
		},
		truncated:
			"Die Liste ist auf das Limit des Anbieters begrenzt, deshalb werden einige Token nicht angezeigt.",
		actions: {
			revoke: "Widerrufen",
			copy: "Kopieren",
			done: "Fertig",
		},
		create: {
			name: "Name",
			nameHint: "1–{max} Zeichen, zum Beispiel das Skript oder der Job, der es verwendet.",
			expires: "Läuft ab",
			neverExpires: "Läuft nie ab",
			summary: "{permissions} für {layers}",
			noGrantable:
				"Es gibt keine Projekte oder Dataspaces, auf die Sie Berechtigungen vergeben können.",
		},
		tree: {
			label: "Projekte und Dataspaces",
			filter: "Projekte und Dataspaces filtern",
			noMatch: "Keine Treffer.",
			selectEverything: "Alles auswählen",
			selectAllIn: "Alles in {name} auswählen",
			unnamedProject: "Unbenanntes Projekt",
			projectLevel: "Projektebene",
			expand: "{name} aufklappen",
			collapse: "{name} zuklappen",
			count: "{ticked}/{total}",
		},
		pane: {
			selectAll: "Alle {count} Berechtigungen auswählen",
			readRequired: "Wird von einer anderen Berechtigung hier vorausgesetzt",
			groupCount: "{ticked}/{total} ausgewählt",
			noLayer:
				"Wählen Sie ein Projekt oder einen Dataspace, um dessen Berechtigungen auszuwählen.",
		},
		validation: {
			nameRequired: "Geben Sie einen Namen ein.",
			nameTooLong: "Der Name darf höchstens {max} Zeichen lang sein.",
			permissionRequired: "Wählen Sie mindestens eine Berechtigung.",
			permissionsTooMany:
				"Ein Token kann höchstens {max} Berechtigungen enthalten; ausgewählt sind {count}.",
			expiryRange: "Wählen Sie einen Zeitpunkt innerhalb der nächsten {days} Tage.",
		},
		secret: {
			title: "Ihr neues Token",
			warning:
				"Dieses Geheimnis wird nur einmal angezeigt, kopieren Sie es also jetzt. Geht es verloren, müssen Sie ein neues Token erstellen.",
			copied: "Kopiert.",
			copyFailed:
				"Kopieren fehlgeschlagen. Markieren Sie das Geheimnis und kopieren Sie es von Hand.",
		},
	},
};
